import { X } from "lucide-react";
import { useState } from "react";
import { storeForThisDevice } from "@/lib/stores";
import { t } from "@shared/i18n";

const KEY = "gbc.app-banner-closed";
const PAUSE_DAYS = 30;

function closedRecently() {
  try {
    const at = Number(localStorage.getItem(KEY));
    return Boolean(at) && Date.now() - at < PAUSE_DAYS * 86400_000;
  } catch {
    return false;
  }
}

/** Bannière « Installez l'appli » pour les visiteurs sur téléphone, vers l'App Store ou Google Play selon l'appareil. */
export function AppBanner() {
  const [target] = useState(storeForThisDevice);
  const [open, setOpen] = useState(() => Boolean(target) && !closedRecently());
  if (!target || !open) return null;
  const close = () => {
    try {
      localStorage.setItem(KEY, String(Date.now()));
    } catch {
      /* stockage indisponible : fermée pour cette visite */
    }
    setOpen(false);
  };
  return (
    <div role="complementary" aria-label={t("Application mobile")} className="pt-safe fixed inset-x-0 top-0 z-50 px-3 pb-2 animate-fade-up">
      <div className="mx-auto mt-2 flex max-w-md items-center gap-3 rounded-2xl border border-border bg-elevated p-2.5 pr-3 shadow-card">
        <button type="button" onClick={close} className="press flex size-8 shrink-0 items-center justify-center rounded-full text-muted hover:text-fg" aria-label={t("Fermer")}>
          <X className="size-4" />
        </button>
        <img src="/icons/icon-192.png" alt="" className="size-11 shrink-0 rounded-[12px]" />
        <div className="min-w-0 flex-1 leading-tight">
          <p className="truncate text-[14px] font-semibold">GBC Coach IA</p>
          <p className="truncate text-[12px] text-muted">{t("Installez l'appli gratuite")}</p>
        </div>
        <a href={target.url} target="_blank" rel="noopener noreferrer" onClick={close} className="press shrink-0 rounded-full bg-brand px-4 py-2 text-[13px] font-bold text-brand-fg">
          {t("Installer")}
        </a>
      </div>
    </div>
  );
}
